import { useContext } from 'react'

import { AppContext } from 'state/appContext'

const useAppContext = () => {
  return useContext(AppContext)
}

export { useAppContext }
